import { IonGrid, IonRow, IonCol, IonButton, IonLabel, IonSlides, IonSlide, IonInput, IonModal, IonContent } from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, {useState, useContext, useEffect, useRef} from 'react';

import { EnterPasswordModal } from '../../../zInternal_Features/merchant/components/Modal_EnterPassword';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { TakePhoto, photos } from '../../../zInternal_Features/merchant/components/TakePhoto';
import { AddSupplierModal } from '../../../zInternal_Features/merchant/components/Modal_AddSupplier';

import '../../../../css/qavaApp.css';


export function CreateInventoryItemModal (props) {



    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [showPasswordModal, setShowPasswordModal] = useState(false); 
    let [showSupplierModal, setShowSupplierModal] = useState(false);

    let [takePhotoStatus, setTakePhotoStatus] = useState(false);
    let [selectedFile, setSelectedFile] = useState(null);

    let [supplierName, setSupplierName] = useState('');
    let [supplierPhone, setSupplierPhone] = useState('');
    let [supplierAddress, setSupplierAddress] = useState('');
    let [supplierCity, setSupplierCity] = useState('');
    let [supplierCountry, setSupplierCountry] = useState('');


    let createItemNameRef = useRef('');
    let createItemDescriptionRef = useRef('');
    let vendorPartNumRef = useRef('');
    let vendorNameRef = useRef('');
    let vendorPhoneNumberRef = useRef('');
    let vendorAddressRef = useRef('');
    let vendorCityRef = useRef('');
    let vendorCountryRef = useRef('');
    let itemCostPerUnitRef = useRef();
    let itemQtyInStockRef = useRef();

    let [searchResults, setSearchResults] = useState([]);



    /*useEffect(() => {

        fetch(baseURL+'fileServer/merchants/image-not-available.jpeg')
        .then(res => res.blob())
        .then(data => {

            const blobUrl = URL.createObjectURL(data);

            let noImageFile = new File([data], blobUrl, {
                enctype: 'multipart/form-data',
                type: 'image/jpeg',
                name: 'xImageFile',
                accept: "image/*",
            });
            
            setSelectedFile(noImageFile);
        })
    }, []);*/

    function handleEnterAttachement() {  

        fetch(baseURL+'fileServer/merchants/image-not-available.jpeg')
        .then(res => res.blob())
        .then(data => {

            const blobUrl = URL.createObjectURL(data);

            let noImageFile = new File([data], blobUrl, {
                enctype: 'multipart/form-data',
                type: 'image/jpeg',
                name: 'xImageFile',
                accept: "image/*",
            });
            
            setSelectedFile(noImageFile);

            alert("No Attachment Option checked");

        })
    }

    function searchSupplierList(event)
    {

        let searchCategory = event[0];
        let searchData = event[1];


        first_searchSuppliersInDB(searchCategory, searchData);

    }


    function first_searchSuppliersInDB(searchCategory, searchData, optionsData)
    {
        //let searchData = document.getElementById('searchInventoryItem').value;
        //let optionsData = document.getElementById('searchInventoryItemsList').childNodes;


        /*for (let i = 0; i < optionsData.length; ++i)
        {
            let remove = document.getElementsByClassName('forDontRemoveProjectSearch');

            while(remove.length > 0)
            {
                remove[0].parentNode.removeChild(remove[0]);
            }
        }*/


        let formData = new FormData();
        let Tracker = '';


        if(searchCategory === 'name')
        {
            /*
            formData.append('Tracker', '74002S_N');
            formData.append('user', acctID);
            formData.append('xSupplierSearchName', searchData);
            */

            Tracker = '74002S_N';
        }
        else if(searchCategory === 'phone')
        {
             /*
            formData.append('Tracker', '74002S_P');
            formData.append('user', acctID);
            formData.append('xSupplierSearchPhone', searchData);
            */

            Tracker = '74002S_P';

        }


        /*const requestOptions = {
            method: 'POST',
            credentials: 'include',
            body: formData
        }*/

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: Tracker,
                user: acctID,
                xSupplierSearchName: searchData,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

                        let rows = res.toString().split('~~~');

                        let rowLength = rows.length;

                            for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                            {
                                let cols = rows[rownum].split('|');

                                if(searchCategory === 'name')
                                {
                                    //setSearchResults(cols);

                                    setSearchResults((prevSearchResults) => {
                                        return prevSearchResults.concat({
                                            db_supplierId: cols[0],
                                            db_supplierName: cols[1],
                                            db_supplierPhoneNumber: cols[2],
                                            db_supplierAddressNumber: cols[3],
                                            db_supplierStreetName: cols[4],
                                            db_supplierCity: cols[5],
                                            db_supplierCountry: cols[6],
                                        })
                                    });
                                    //document.getElementById('searchSupplierNameList').insertAdjacentHTML('beforeend', '<option class=\'forRemoveProjectSearch\' data-id=\''+[cols[0], cols[1], searchCategory,]+'\'>'+cols[0]+'</option>'); // onclick=\'inventoryItemsSearchResults('+cols[0]+')\'
                                }
                                else if(searchCategory === 'phone')
                                {

                                    //setSearchResults(cols);

                                    setSearchResults((prevSearchResults) => {
                                        return prevSearchResults.concat({
                                            db_supplierId: cols[0],
                                            db_supplierName: cols[1],
                                            db_supplierPhoneNumber: cols[2],
                                            db_supplierAddressNumber: cols[3],
                                            db_supplierStreetName: cols[4],
                                            db_supplierCity: cols[5],
                                            db_supplierCountry: cols[6],
                                        })
                                    });
                                }
                            }
                    })
    }


    function createInventoryItem(enteredPassword)
    {

        //alert('In createInventoryItem');
        //alert(createItemNameRef.current.value);
        //alert(createItemDescriptionRef.current.value);
        //alert(vendorPartNumRef.current.value);
        //alert(supplierName);
        //alert(supplierPhone);
        //alert(supplierAddress);
        //alert(supplierCity);
        //alert(supplierCountry);
        //alert(itemCostPerUnitRef.current.value);
        //alert(itemQtyInStockRef.current.value);
        //alert(selectedFile);
        //alert(enteredPassword);

        /*
        let formData = new FormData();
        formData.append('Tracker', 74400);
        formData.append('user', acctID);
        formData.append('xInventoryItemName', createItemNameRef.current.value);
        formData.append('xInventoryItemDescription', createItemDescriptionRef.current.value);
        formData.append('xInventoryVendorPartNum', vendorPartNumRef.current.value);
        formData.append('xInventoryVendorName', supplierName);
        formData.append('xInventoryVenderPhoneNumber', supplierPhone);
        formData.append('xInventoryVendorAddress', supplierAddress);
        formData.append('xInventoryVendorCity', supplierCity);
        formData.append('xInventoryVendorCountry', supplierCountry);
        formData.append('xInventoryItemCostPerUnit', itemCostPerUnitRef.current.value);
        formData.append('xInventoryItemQtyInStock', itemQtyInStockRef.current.value);
        formData.append('xImageFile', selectedFile);
        formData.append('xEnterAdminPassword', enteredPassword);


        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74400_retail',
                user: acctID,
                xInventoryItemName: createItemNameRef.current.value,
                xInventoryItemDescription: createItemDescriptionRef.current.value,
                xInventoryVendorPartNum: vendorPartNumRef.current.value,
                xInventoryVendorName: vendorNameRef.current.value,
                xInventoryVenderPhoneNumber: vendorPhoneNumberRef.current.value,
                xInventoryVendorCity: vendorCityRef.current.value,
                xInventoryVendorCountry: vendorCountryRef.current.value,
                xInventoryItemCostPerUnit: itemCostPerUnitRef.current.value,
                xInventoryItemQtyInStock:  itemQtyInStockRef.current.value,
                xImageFile: selectedFile,
                xEnterAdminPassword: enteredPassword,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
        })
        .catch(error => {
            console.error(error);
        })

        props.closeModal(false);
        //setAdminPasswordCreateInventoryItemModal(false);
    }


    function selectedFileHandler(event)
    {
        //alert('In onSelectedFile');
        //alert(event);

        setSelectedFile(event);

    }

    let timeout;

    function handleInput(event) {

        document.getElementById('searchSupplierNameList').innerHTML = '';
        document.getElementById('searchSupplierPhoneNumberList').innerHTML = '';

        clearTimeout(timeout); // Clear the previous timeout to reset the delay
        timeout = setTimeout(searchSupplierList(event), 2000); // Set a new timeout
    
    }

    function onSubmitPasswordHandler(enteredPassword)
    {
        //alert('In onSubmitPasswordHandler');
        //alert(enteredPassword);

        //setEnteredPassword(event);
        createInventoryItem(enteredPassword);
    }

    function closeModalHandler() {

        props.closeModal(false);
    }

    //alert("Create Inventory Item");


    return (

            <React.Fragment>
                {
                props.openModal == true ?
                (
                    <IonModal isOpen={ props.openModal}>
                        <IonContent className='bookedDetails_gridContent_multiple'>
                        <IonSlides pager='true'>
                            <IonSlide>
                                <IonLabel>Item Name: </IonLabel>
                                <IonInput placeholder='Enter Item Name' ref={createItemNameRef}></IonInput>
                            </IonSlide>
                            <IonSlide>
                                <IonLabel>Item Description: </IonLabel>
                                <IonInput placeholder='Enter Item Description' ref={createItemDescriptionRef}></IonInput>
                            </IonSlide>
                            <IonSlide>

                                <IonGrid>
                                    <IonRow>
                                        <IonCol size='12'>
                                            <IonButton  onClick={() => setShowSupplierModal(true)}> Add Supplier</IonButton>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <h3 >Supplier Part Number:</h3>
                                        </IonCol>
                                        <IonCol>
                                            <IonInput placeholder='Enter Item Description' ref={vendorPartNumRef}></IonInput>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <label for='searchSupplierName'>Supplier Name:</label>
                                        </IonCol>
                                        <IonCol>
                                            <input type='text' id='searchSupplierName' ref={ vendorNameRef } placeholder='Search supplier name' onInput={() => handleInput(['name', vendorNameRef.current.value])} list='searchSupplierNameList' autocomplete='off' required></input>
                                            <datalist id='searchSupplierNameList'>
                                                {searchResults.map((result) => (
                                                    <option key={result.db_supplierId} value={result.db_supplierName}></option>
                                                ))}
                                            </datalist>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <label for='searchSupplierPhoneNumber'>Supplier Phone Number:</label>
                                        </IonCol>
                                        <IonCol>
                                            <input type='text' id='searchSupplierPhoneNumber' ref={ vendorPhoneNumberRef }  placeholder='Search supplier phone number' onInput={() => handleInput(['phone', vendorPhoneNumberRef.current.value])} list='searchSupplierPhoneNumberList' autocomplete='off' required></input>
                                            <datalist id='searchSupplierPhoneNumberList'>
                                                {searchResults.map((result) => (
                                                    <option key={result.db_supplierId} value={result.db_supplierPhoneNumber}></option>
                                                ))}
                                            </datalist>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <h3>Supplier Address:</h3>
                                        </IonCol>
                                        <IonCol>
                                            <input type='text' ref={ vendorAddressRef } placeholder='Vendor Address' autocomplete='off' required></input>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <h3>Supplier City:</h3>
                                        </IonCol>
                                        <IonCol>
                                            <input type='text' ref={ vendorCityRef } placeholder='Vendor City' autocomplete='off' required></input>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <h3>Supplier Country:</h3>
                                        </IonCol>
                                        <IonCol>
                                            <input type='text' ref={ vendorCountryRef } placeholder='Vendor Country' autocomplete='off' required></input>
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>

                                <AddSupplierModal  openModal={ showSupplierModal } closeModal={() => setShowSupplierModal(false)}></AddSupplierModal>

                            </IonSlide>
                            <IonSlide>
                                <IonLabel>Cost Per Unit: </IonLabel>
                                <IonInput placeholder='Enter Item Description' ref={itemCostPerUnitRef}></IonInput>
                            </IonSlide>
                            <IonSlide>
                                <IonLabel>Qty In stock: </IonLabel>
                                <IonInput placeholder='Enter Item Description' ref={itemQtyInStockRef}></IonInput>
                            </IonSlide>
                            <IonSlide>
                                <IonLabel>Attachement </IonLabel>
                                <IonGrid> 
                                    <IonRow>
                                        <IonCol>
                                            <h1>Upload Supporting Documentation</h1>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <form id='fileUpload' enctype='multipart/form-data'>
                                                <input type='file' name='imageFile' accept="image/*" onChange={(e) => selectedFileHandler(e.target.files[0])}></input>
                                                <label for='noAttachment'>No Attachment</label>
                                                    <input type='checkbox' id='noAttachment' value='noImage' onClick={(e) => handleEnterAttachement()}></input>
                                                {/*<input type="button" value="upload" onClick={uplodFile} ></input>*/}
                                            </form>
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>

                                <IonButton onClick={() => setShowPasswordModal(true)}> Confirm Item Creation </IonButton> 

                                <EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>                        
                            
                            </IonSlide>
                        </IonSlides>
                        <IonButton onClick={() => props.closeModal(false)}>Cancel </IonButton>
                    </IonContent>
                </IonModal>) : null
                }
            </React.Fragment>

    )
}